import React from "react";
import MyResume from "../docs/myresume.pdf";

const ResumeDownload = ({ paddingY, paddingX }) => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = MyResume;
    link.download = "resume.pdf";
    link.click();
  };

  return (
    <div>
      <button className="btn btn-primary py-3 px-3" onClick={handleDownload}>
        Download CV
      </button>
    </div>
  );
};

export default ResumeDownload;
